import {Card as MUICard} from '@mui/material'

export const Card = MUICard
